import { axiosInstance } from "../utils/axiosinstance";

export interface ProjectFilters {
  hackathonId?: string;
  isVisible?: boolean;
  isFeatured?: boolean;
  page?: number;
  limit?: number;
}

export interface Project {
  _id: string;
  title: string;
  description: string;
  industry?: string;
  demoLink: string;
  documentUrl?: string;
  supportingLinks?: Array<{ url: string; description?: string }>;
  googleTechnologies?: string[];
  otherTechnologies?: string[];
  hackathonId?: string;
  ownerName?: string;
  ownerEmail?: string;
  isFeatured?: boolean;
  isVisible?: boolean;
  tag?: "hackathon" | "internal";
  documentation?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateProjectData {
  title: string;
  description: string;
  industry?: string;
  demoLink: string;
  documentUrl?: string;
  supportingLinks?: Array<{ url: string; description?: string }>;
  googleTechnologies?: string[];
  otherTechnologies?: string[];
  hackathonId?: string;
  ownerName?: string;
  ownerEmail?: string;
  documentation?: string;
}

// Get all projects (admin only, includes hidden)
export const getAllProjects = async (filters: ProjectFilters = {}) => {
  try {
    const params = new URLSearchParams();

    if (filters.hackathonId) params.append("hackathonId", filters.hackathonId);
    if (filters.isVisible !== undefined)
      params.append("isVisible", filters.isVisible.toString());
    if (filters.isFeatured !== undefined)
      params.append("isFeatured", filters.isFeatured.toString());
    if (filters.page) params.append("page", filters.page.toString());
    if (filters.limit) params.append("limit", filters.limit.toString());

    const response = await axiosInstance.get(
      `/api/v1/projects/admin/projects?${params.toString()}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Error fetching all projects:", error);
    throw error;
  }
};

// Get project by ID
export const getProjectById = async (id: string) => {
  try {
    const response = await axiosInstance.get(`/api/v1/projects/${id}`);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching project by ID:", error);
    throw error;
  }
};

// Create manual project (admin only)
export const createProject = async (data: CreateProjectData) => {
  try {
    const response = await axiosInstance.post(
      `/api/v1/projects/admin/projects`,
      data
    );
    return response.data;
  } catch (error: any) {
    console.error("Error creating project:", error);
    throw error;
  }
};

// Update project (admin only)
export const updateProject = async (id: string, data: Partial<CreateProjectData>) => {
  try {
    const response = await axiosInstance.put(
      `/api/v1/projects/admin/projects/${id}`,
      data
    );
    return response.data;
  } catch (error: any) {
    console.error("Error updating project:", error);
    throw error;
  }
};

// Toggle featured status (admin only)
export const toggleFeatured = async (id: string) => {
  try {
    const response = await axiosInstance.post(
      `/api/v1/projects/admin/projects/${id}/feature`
    );
    return response.data;
  } catch (error: any) {
    console.error("Error toggling featured:", error);
    throw error;
  }
};

// Toggle visibility (admin only)
export const toggleVisibility = async (id: string) => {
  try {
    const response = await axiosInstance.post(
      `/api/v1/projects/admin/projects/${id}/visibility`
    );
    return response.data;
  } catch (error: any) {
    console.error("Error toggling visibility:", error);
    throw error;
  }
};

